// extracted by mini-css-extract-plugin
export var chatHtmlText = "_sw-2";
export var chatLink = "_sw-0";
export var chatText = "_sw-1";